var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManyAmenities = function SvgManyAmenities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#many-amenities_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.075 5.43c3.55 0 6.427 2.809 6.427 6.272q0 .101-.005.201.005.129.005.264c0 .206-.045.465-.125.768a6.1 6.1 0 0 1-.587 1.637c-1.308 3.09-4.111 7.82-5.715 10.139-1.603-2.319-4.407-7.05-5.716-10.139a6.1 6.1 0 0 1-.586-1.636 3.2 3.2 0 0 1-.125-.769q0-.135.004-.263l-.004-.202c0-3.463 2.878-6.271 6.427-6.271Zm0 3.717c-1.446 0-2.618 1.144-2.618 2.555s1.172 2.556 2.618 2.556 2.618-1.144 2.618-2.556c0-1.41-1.172-2.555-2.618-2.555",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M37.096 17.27c1.242 0 1.072.338 1.072 1.522v1.353c0 .423-.845 1.353-1.522 1.183l.45-.608c0 .056.698-.442-.225.304l-.394.304-2.706 11.839c-.08.348-.965 1.353-1.327 1.353l-14.998-.767a.774.774 0 0 1-.756-.595L13.848 20.89a.8.8 0 0 1-.02-.171h-.973a.77.77 0 0 1-.776-.767l-1.477-1.669c0-.423 1.824-1.014 2.252-1.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M13.003 20.906h21.905c.29 0 .505.27.44.552l-2.874 12.459a.45.45 0 0 1-.44.35H15.877a.45.45 0 0 1-.44-.35l-2.873-12.459a.45.45 0 0 1 .439-.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M11.135 21.074h25.65a.45.45 0 0 0 .45-.451V18.65a.45.45 0 0 0-.45-.45h-25.65a.45.45 0 0 0-.451.45v1.973c0 .25.202.451.45.451Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.529,
    d: "m23.725 23.046 4.781-9.392a.905.905 0 1 0-1.613-.821l-4.782 9.392a.905.905 0 0 0 1.614.821Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "many-amenities_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgManyAmenities;